import React, { useState, useEffect, useCallback } from 'react';
import TrainersNavbar from './TrainerNavbar';
import '../styles/TrainersStudent.css'; // Ensure the CSS file is inside the src/styles directory

const TrainersStudent = () => {
  const [students, setStudents] = useState([]);
  const [groupName, setGroupName] = useState('');
  const [trainerName, setTrainerName] = useState('');
  const [trainerEmail, setTrainerEmail] = useState('');
  const [allRows, setAllRows] = useState([]);
  const [otherGroups, setOtherGroups] = useState([]);

  useEffect(() => {
    const fetchAssignedGroup = async () => {
      try {
        const trainerName = localStorage.getItem('trainerName');
        const trainerEmail = localStorage.getItem('trainerEmail');
        setTrainerName(trainerName);
        setTrainerEmail(trainerEmail);

        const response = await fetch(`https://backend-main-4.onrender.com/api/assigned-group?trainer=${trainerName}`);
        if (response.ok) {
          const data = await response.json();
          setGroupName(data.group);
          setStudents(data.students);
        } else {
          throw new Error('Failed to fetch assigned group.');
        }
      } catch (error) {
        console.error('Error fetching assigned group:', error);
      }
    };

    const fetchAllRows = async () => {
      try {
        const response = await fetch('https://backend-main-4.onrender.com/data');
        const rows = await response.json();
        setAllRows(rows);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchAssignedGroup();
    fetchAllRows();
  }, []);

  const filterStudentsByGroup = useCallback((group) => {
    let filteredStudents = [];
    if (group === 'Excellent') {
      filteredStudents = allRows.filter(row => {
        const html = parseFloat(row[10]);
        const css = parseFloat(row[11]);
        const js = parseFloat(row[12]);
        const average = (html + css + js) / 3;
        return average > 50 && parseFloat(row[6]) > 60 && parseFloat(row[7]) > 60 && parseFloat(row[8]) > 60;
      });
    } else if (group === 'Capable') {
      filteredStudents = allRows.filter(row => {
        const html = parseFloat(row[10]);
        const css = parseFloat(row[11]);
        const js = parseFloat(row[12]);
        const average = (html + css + js) / 3;
        return average <= 50 && parseFloat(row[6]) > 60 && parseFloat(row[7]) > 60 && parseFloat(row[8]) > 60;
      });
    } else if (group === 'Idle') {
      filteredStudents = allRows.filter(row => parseFloat(row[6]) <= 60 || parseFloat(row[7]) <= 60 || parseFloat(row[8]) <= 60);
    }
    setStudents(filteredStudents);
  }, [allRows]);

  useEffect(() => {
    if (groupName) {
      filterStudentsByGroup(groupName);
    }
  }, [groupName, allRows, filterStudentsByGroup]);

  useEffect(() => {
    const fetchOtherGroups = async () => {
      try {
        const response = await fetch(`http://localhost:3009/api/other-groups?email=${trainerEmail}`);
        const data = await response.json();
        setOtherGroups(data);
      } catch (error) {
        console.error('Error fetching other groups:', error);
      }
    };

    if (trainerEmail) {
      fetchOtherGroups();
    }
  }, [trainerEmail]);

  return (
    <div>
      <TrainersNavbar />
      <div className="container mt-5">
        <h2 className="text-center">Assigned Students</h2>
        <p className="welcome-message">Welcome, {trainerName}!</p>
        {groupName ? (
          <>
            <h3 className="text-center">Group: {groupName}</h3>
            <table className="students-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Roll Number</th>
                  <th>Department</th>
                  <th>Class</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <tr key={index}>
                    <td>{student[1]}</td>
                    <td>{student[0]}</td>
                    <td>{student[5]}</td>
                    <td>{student[4]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <p className="no-group-message">You have not been assigned to any group yet.</p>
        )}
        {otherGroups.length > 0 && (
          <div className="other-groups mt-5">
            <h3 className="text-center">Other Groups</h3>
            {otherGroups.map((group, index) => (
              <div key={index} className="group-section">
                <h4>{group.name}</h4>
                <table className="students-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Roll Number</th>
                      <th>Department</th>
                      <th>Class</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.students.map((student, idx) => (
                      <tr key={idx}>
                        <td>{student[1]}</td>
                        <td>{student[0]}</td>
                        <td>{student[5]}</td>
                        <td>{student[4]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TrainersStudent;
